<template>
  <div class="kjt">
    <!-- Nesne: key -> deger (deger primitive ise inline, degilse alt agac) -->
    <template v-if="kind === 'object'">
      <div v-for="(v, k) in value" :key="k" class="kjt-row">
        <span class="kjt-key">{{ k }}</span>
        <span v-if="isPrimitive(v)" class="kjt-val" :class="cls(v)">{{
          fmt(k, v)
        }}</span>
        <div v-else class="kjt-nested">
          <span class="kjt-brace">{{ Array.isArray(v) ? "[" + v.length + "]" : "{ }" }}</span>
          <krJsonTree :value="v" :parentKey="k" />
        </div>
      </div>
      <div v-if="objectEmpty" class="kjt-empty">boş</div>
    </template>

    <!-- Dizi: her oge indeksli; oge primitive ise inline, degilse alt agac -->
    <template v-else-if="kind === 'array'">
      <div v-if="value.length === 0" class="kjt-empty">boş</div>
      <div v-for="(item, i) in value" :key="i" class="kjt-item">
        <span class="kjt-index">{{ i + 1 }}.</span>
        <span v-if="isPrimitive(item)" class="kjt-val" :class="cls(item)">{{
          fmt(parentKey, item)
        }}</span>
        <div v-else class="kjt-nested">
          <krJsonTree :value="item" :parentKey="parentKey" />
        </div>
      </div>
    </template>

    <!-- Primitive (nadiren en ust) -->
    <span v-else class="kjt-val" :class="cls(value)">{{ fmt(parentKey, value) }}</span>
  </div>
</template>

<script>
import moment from "moment";
// Herhangi bir JSON degerini (obje / dizi / primitive, ic ice) okunabilir
// gosteren recursive renderer. PMS'e gore row sekli degisse de calisir.
export default {
  name: "krJsonTree",
  props: {
    value: { default: null },
    parentKey: { type: String, default: "" },
  },
  computed: {
    kind() {
      if (Array.isArray(this.value)) return "array";
      if (this.value !== null && typeof this.value === "object") return "object";
      return "primitive";
    },
    objectEmpty() {
      return (
        this.kind === "object" && Object.keys(this.value || {}).length === 0
      );
    },
  },
  methods: {
    isPrimitive(v) {
      return v === null || typeof v !== "object";
    },
    cls(v) {
      if (v === null || v === undefined || v === "") return "empty";
      if (typeof v === "boolean") return v ? "bool-ok" : "bool-no";
      return "";
    },
    fmt(key, v) {
      if (v === null || v === undefined || v === "") return "—";
      if (typeof v === "boolean") return v ? "Evet" : "Hayır";
      if (
        typeof v === "string" &&
        (key === "Checkin" || key === "Checkout" || /Date$/.test(key || ""))
      ) {
        const d = new Date(v);
        if (!isNaN(d.getTime())) {
          const hasTime = /T\d/.test(v) && !/T00:00:00/.test(v);
          return moment(d).format(hasTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY");
        }
      }
      return String(v);
    },
  },
};
</script>

<style scoped>
.kjt-row,
.kjt-item {
  display: flex;
  gap: 10px;
  padding: 2px 0;
  align-items: baseline;
}
.kjt-item {
  align-items: flex-start;
}
.kjt-key {
  flex: 0 0 auto;
  min-width: 130px;
  max-width: 45%;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-tertiary, #9a9aa2);
  word-break: break-word;
}
.kjt-index {
  flex: 0 0 auto;
  font-size: 11.5px;
  color: var(--text-tertiary, #9a9aa2);
}
.kjt-val {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--text-primary, #23232a);
  word-break: break-word;
}
.kjt-val.empty {
  color: var(--text-tertiary, #c2c2c9);
}
/* Evet/Hayır deger, basari degil -> proje mavisi (kr-pill.ok ile ayni mantik) */
.kjt-val.bool-ok {
  color: #1565c0;
  font-weight: 600;
}
.kjt-val.bool-no {
  color: var(--text-secondary, #8a8a93);
}
.kjt-nested {
  flex: 1 1 100%;
  margin-left: 4px;
  padding-left: 12px;
  border-left: 1px solid var(--border-default, #e6e6ea);
}
.kjt-brace {
  font-size: 11px;
  color: var(--text-tertiary, #a7a7af);
}
.kjt-empty {
  font-size: 12px;
  font-style: italic;
  color: var(--text-tertiary, #b6b6bd);
}
</style>
